import { isTaxSupported } from '../locales/helpers';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';

type PlusTaxProps = {
  locale: string | undefined;
  visible: boolean;
};
export const PlusTax: FC<PlusTaxProps> = (props) => {
  const { locale, visible } = props;
  const { t } = useTranslation();

  return (
    <>
      {isTaxSupported(locale) && (
        <span style={{ visibility: visible ? 'visible' : 'hidden', fontWeight: 'normal' }}>{t('plusTax')}</span>
      )}
    </>
  );
};
